import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import { AssetGroup } from '@play-co/timestep-core';
import { FlexBoxImageView, FlexBoxView } from '@play-co/timestep-core/flexbox';
import { track } from 'src/lib/analytics/utils';
import { Feature } from 'src/replicant/analytics';

const assets = {
  graphic: 'assets/miniapp/graphic_miniapp_purchase_tos.png',
};

export default class PopupDailyBonusTosNudge extends PopupBasic {
  protected getAssetsGroup() {
    return new AssetGroup(Object.values(assets));
  }

  constructor(opts: { superview: View; close: (accepted: boolean) => void }) {
    super({
      superview: opts.superview,
      zIndex: 10000,
      width: 563,
      height: 598,
      darkerBg: false,
      close: () => opts.close(false),
      tracking: {
        feature: Feature.MATCH2.DAILY_BONUS._,
        $subFeature: Feature.MATCH2.DAILY_BONUS.TOS_NUDGE._,
      },
    });

    // Remove default close button - user must click Continue
    this.buttonClose.removeFromSuperview();

    // Create a flex wrapper container
    const wrapper = new FlexBoxView({
      superview: this.box,
      flex: {
        width: this.box.style.width,
        height: this.box.style.height,
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: 100,
        paddingBottom: 38,
      },
    });

    // Create graphic image
    new FlexBoxImageView({
      superview: wrapper,
      image: assets.graphic,
      flex: {
        width: 404,
        height: 258,
      },
    });

    // Create message label
    this.message.updateOpts({
      superview: wrapper,
      width: this.box.style.width - 80,
      height: 70,
    });

    // Create CTA button
    new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: wrapper,
      labelOffsetY: -3,
      fontSize: 48,
      font: 'Body',
      width: 315,
      height: 87,
      localeText: () => i18n('match2.dailyBonus.tosNudgePopup.cta'),
      onClick: async () => {
        opts.close(true);
      },
      tracking: {
        feature: Feature.MATCH2.DAILY_BONUS._,
        $subFeature: Feature.MATCH2.DAILY_BONUS.TOS_NUDGE.CONTINUE,
      },
    });
  }

  public init() {
    super.init({
      title: i18n('match2.dailyBonus.tosNudgePopup.title'),
      message: i18n('match2.dailyBonus.tosNudgePopup.message'),
    });

    this.title.updateOpts({
      size: 32,
      leading: -20,
    });

    // Track view event
    track('DailyBonusPurchaseTOSNudgeView', {});
  }
}
